define(
    'LNRS/Components/Charts/line',["jquery", "d3", "scrollMagic", "mustache", "LNRS/Components/Charts/Base"],
    function ($, d3, ScrollMagic, mustache, Base) {
        "use strict";

        function LineChart(scope, chartInfo, id) {
            Base.call(this, scope, chartInfo, id);
        }

        LineChart.prototype = Object.create(Base.prototype);

        var svgWidth, svgHeight;

        LineChart.prototype.initChart = function initChart(gDiv, dataset) {

            // div to hold tooltips
            var tooltipBox = [
                [ 0, 0],
                [ 0,30],
                [22,30],
                [25,34],
                [29,30],
                [50,30],
                [50, 0],
                [0,0]
            ];
    
            var svgWidth = $(gDiv).width(),
            svgHeight = 350,
            hasBeenTouchedRecently = false;
        
            //less height for mobile
            if ( $(window).width() < 810 ) {
                svgHeight = 350;
            } else {
                svgHeight = 450;
            }
                
            var svg = d3.select(gDiv)
            .append('svg')
            .attr('width', svgWidth)
            .attr('height', svgHeight );

            svg.style('position','relative');
                
            // shadow for tooltip
            var chartDefs = svg.append('defs');
            var chartFilter = chartDefs.append('filter')
                .attr('id','shadow')
                .attr('x','0')
                .attr('y','0');
            chartFilter.append('feOffset')
                .attr('result','offOut')
                .attr('in','SourceAlpha')
                .attr('dx','-5')
                .attr('dy','-5');
            chartFilter.append('feGaussianBlur')
                .attr('result','blurOut')
                .attr('in','offOut')
                .attr('stdDeviation','6');
            chartFilter.append('feBlend')
                .attr('in','SourceGraphic')
                .attr('in2','blurOut')
                .attr('mode','normal');

    /*
    // clean  up data    
    var parseDate = d3.timeParse("%Y");
    dataset.points.forEach(function(d) {
        d.forEach(function(e){
            e.date = parseDate(e.date);
            e.line = +e.line;
        })
    })
    */
    
            var svg = d3.select(gDiv + " svg");
            // get width and height
            var svgWidth = svg.attr('width');
            var svgHeight = svg.attr('height');
            // add tooltip div
            var div = d3.select(gDiv).append("div").attr("class", "tooltip-c pies").style("min-width","24px");

            //
            $(gDiv).addClass('scrollable');
            $(gDiv).append('<div class="scrol-prev" style="left: 70px;"></div>');
            $(gDiv).append('<div class="scrol-next"></div>');
            
            var margin = { top: 20, right: 20, bottom: 70, left: 70 },
                chartWidth  = svgWidth  - margin.left - margin.right,
                chartHeight = svgHeight - margin.top  - margin.bottom; 

            // nebo request
            var chartInset = 30,
                realChartWidth = 830;

            if ( $(window).width() > 992  && $(gDiv).width() < 830 ) {
                // desktop & chart not full content width
                realChartWidth = chartWidth ;
            } else {
                realChartWidth = 760;
            }
    
            var chartWrapper = svg.append('g')
                .style('font-family',"'Source Sans Pro'")
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            // clip rectangle - visible area
            var clipWrap = chartWrapper.append('clipPath')
            .attr('id','clipChart')
            .append('rect')
                .attr('x',0)
                .attr('y',0)
                .attr('width', realChartWidth)
                .attr('height',chartHeight + 60);

            var innerBox = chartWrapper.append('g')
                .attr('class','inner-wrapper')
                .attr('style','clip-path: url(#clipChart)')
                .attr("transform","translate(0,0)")
                .append("g")
                .attr("class","scrollingChart")
                .style('transition','all .4s ease');

/*
 *  init axes
 *
 */ 
 
            //var yTicks = dataset.yTickLabels.length;
            var xMaxValue = dataset.xTickLabels.length - 1,
                xMinValue = 0;

            var y = d3.scaleLinear()
                .domain([dataset.yMinValue, dataset.yMaxValue])        // values between min and max
                .range([chartHeight, 0])                            // map these to the chart height. 
                ;    
                //REMEMBER: y axis range has the bigger number first because the y value of zero 
                //is at the top of chart and increases as you go down.
                    
                // define the x scale (horizontal)
            var x = d3.scaleLinear()
                .domain([xMinValue, xMaxValue])    // values between for month of january
                .range([0, realChartWidth - chartInset * 2]);   // map these the the chart width = total width minus padding at both sides
            
            // define the y axis
            var yAxis = d3.axisLeft()
                .scale(y)
                .tickFormat(d3.format(dataset.yTickFormat));
                
            if (dataset.gridLines ==1) {
                yAxis.tickSizeInner(-chartWidth);
            }
            // define the x axis
            var xAxis = d3.axisBottom()
                .scale(x)
                .ticks(xMaxValue);
                    
            // draw y axis with labels 
            chartWrapper.append("g")
                .attr("class","y-axis")
                .attr("transform", "translate(0,0)")
                .attr("font-size",14)
                .call(yAxis)
                .attr('font-family', "'Source Sans Pro'")
                .selectAll(".tick line")
                .attr("stroke", "#ccc");
            // animate grid lines
            chartWrapper.selectAll('.y-axis line')
            .attr('stroke-dasharray',chartWidth + ' ' + chartWidth )
            .attr('stroke-dashoffset', chartWidth)
            .transition()
                .duration(1000)
                .attr("stroke-dashoffset", 0);

            d3.select(gDiv + ' .y-axis .tick:nth-child(2) line').attr('stroke','none');
                
            chartWrapper.selectAll(".y-axis .tick text")
                .attr('font-size', "14");

            // draw x axis with labels and move to the bottom of the chart area
            innerBox.append("g")
                .attr("class", "x-axis")   // give it a class so it can be used to select only xaxis labels  below
                .attr("transform", "translate(" + chartInset + "," + chartHeight + ")")
                .attr("font-size",14)
                .call(xAxis)
                .attr('font-family', "'Source Sans Pro'")
                .selectAll(".tick line")
                .attr("stroke", "#ccc");
            innerBox.selectAll(".x-axis .tick text")
                .attr('font-size', "14");
        
            // replace y axis labels with custom ones
            //$.each($(gDiv + " .y-axis text"),function(i, v){
            //    v.innerHTML = dataset.yTickLabels[i];
            //});

            // replace x axis labels with custom ones
            $.each($(gDiv + " .x-axis text"),function(i, v){
                //v.innerHTML = dataset.xTickLabels[i];
                v.textContent = dataset.xTickLabels[i];
            });
            
            // axes titles 
            chartWrapper.append("text")
                .text(dataset.yTitle)
                .attr('y',-50)
                .attr('x', -(chartHeight / 2))
                .attr('font-size', 10)
                .attr('text-anchor','middle')
                .attr("style","text-transform:uppercase")
                .attr("transform", "rotate(-90)");
                
            chartWrapper.append("text")
                .text(dataset.xTitle)
                .attr('y', chartHeight + 50)
                .attr('x', (chartWidth / 2))
                .attr('text-anchor','middle')
                .attr("style","text-transform:uppercase")
                .attr('font-size', 10);

/*
 * check if there are enough colors for all lines
 */
            if (dataset.colors.length && dataset.points.length) {
                while (dataset.colors.length < dataset.points[0].length) {
                    dataset.colors = dataset.colors.concat(dataset.colors);
                }
            }
 
 
            var valueline = d3.line()
                .x(function(d,i) { 
                    return x(i) + chartInset; 
                })
                .y(function(d) { 
                    return y(d);
                });

            dataset.points.forEach(function(d,j){
                innerBox.append("path")
                    .attr("class", "line")
                    .attr("id", "line" + j)
                    .attr("fill","none")
                    .attr("d", valueline(d))
                    .style("stroke", dataset.colors[j])
                    .style("stroke-width", "0")
                    .style("opacity","0");
            });

    // add hotspots    
            dataset.points.forEach(function(d,j){
                
                innerBox.selectAll("dot")    
                    .data(d)            
                    .enter().append("circle")                                
                    .attr("r", 8)    
                    .attr("data-color",dataset.colors[j])            
                    .attr("cx", function(d,i) { 
                        return x(i) + chartInset; 
                    })         
                    .attr("cy", function(d) { 
                        return y(d); 
                    })
                    .attr("fill","transparent")
                    .attr("stroke", "transparent")
                    .style("opacity", "0")
                    .on("mouseleave", function() {
                        //hide circle
                        $(this).css("fill", "transparent")
                        .removeClass('open')
                        .css("opacity", "0");
                        $(gDiv + " .tooltip-c")
                                    .css("opacity","0");
        /*
                                    .css("top","0")
                                    .css("left","0");
        /*
                        var div = d3.select(gDiv + " .tooltip-c");
                        div.style("opacity",0);
                        div.style("top",0);
                        div.style("left",0);
        */
                    })
                    .on('mouseup touchend mouseenter', function(d){
                        d3.event.stopPropagation();
                        d3.event.preventDefault();
                        if(hasBeenTouchedRecently) {
                            return false;
                        }
                        hasBeenTouchedRecently = true;
                        setTimeout(function() { 
                            hasBeenTouchedRecently = false; 
                        }, 500);
                        
                        if ($(this).hasClass('open')) {
                            $(this).css("fill", "transparent")
                            .removeClass('open')
                            .css("opacity", "0");
                            
                            $(gDiv + " .tooltip-c")
                                .css("opacity","0");
                        } else {
                            //hide all circles
                            $(gDiv + ' svg circle').css("fill", "transparent")
                                .removeClass('open')
                                .css("opacity", "0");
        
                            $(gDiv + " .tooltip-c")
                            .css("opacity","0");
                
        
                            $(this).css("fill", "#666")
                            .addClass('open')
                            .css("opacity", "1");
                            var lc = $(this).attr("data-color");
                        
                            var div = d3.select(gDiv + " .tooltip-c");
                            var offset = $(gDiv).offset();
                            div.html("<p style='color:"+lc+"'>"+ d3.format(",")(d) + "</p>");
                            
                            var ttBox = div.node().getBoundingClientRect();
                            //var f = d3.format(dataset.tooltipFormat);
                            
                            // calc position
                            var cirPos = $(this)[0].getBBox();
                            //get scroll offset
                                //get transform css
                                var tmp = $(gDiv + ' g.scrollingChart').attr('style');
                                var scOffset = 0;
                                if( tmp.includes('transform') ) {
                                    scOffset = parseInt(tmp.split(';')[1].split('(')[1]);
                                    if( isNaN(scOffset) ) {
                                        scOffset = 0;
                                    } 
                                }
                            //var scOffset = parseInt($(gDiv + ' g.scrollingChart').css('transform').split(',')[4]);
                            if (!scOffset) scOffset = 0;
            
                            $(gDiv + " .tooltip-c").css("left", (cirPos.x + scOffset + 10 + margin.left - ttBox.width/2  )+"px")
                                .css("top", (cirPos.y  + margin.top -35 ) +"px")
                                .css("opacity", "1");
            
                        }
                        return false;
                    });


            });

                    // add event to any click on svg
                    $(gDiv).on('mouseup touchend', function(){
                        $(gDiv + ' svg circle').css("fill", "transparent")
                        .removeClass('open')
                        .css("opacity", "0");
                        
                        $(gDiv + " .tooltip-c")
                            .css("opacity","0");
                
                    });
            

                    $(document).on('mouseup touchend', gDiv + ' .scrol-next', [], function(){
                        if(hasBeenTouchedRecently) {
                            return false;
                        }
                        hasBeenTouchedRecently = true;
                        setTimeout(function() { 
                            hasBeenTouchedRecently = false; 
                        }, 500);

                        var myChart = $(this).parent().find('.scrollingChart');
                        var moveWindow = $(this).parent()[0].getBoundingClientRect().width - margin.left - margin.right ,
                            moveDist = moveWindow * 0.8; 

                        var myWidth = myChart[0].getBBox().width;
                        //get transform css
                        var tmp = myChart.attr('style');
                        var currPos = 0;
                        if( tmp.includes('transform') ) {
                            currPos = parseInt(tmp.split(';')[1].split('(')[1]);
                            if( isNaN(currPos) ) {
                                currPos = 0;
                            } 
                        }
                        
                        // get tick distance 
                        var vv = [] ;
                        $(gDiv + ' .x-axis .tick').each(function(i){
                            vv[i] = $(this).attr('transform');
                        });
                        var tickDist = parseInt(vv[1].split('(')[1]) - parseInt(vv[0].split('(')[1]);
                        //if ticks spacing > move distance - center second tick
                        // and make move dist = spacer dist
                        if ( tickDist > moveDist ) {
                            if ( currPos == 0 ) {
                                moveDist =  tickDist - moveWindow/2 + 30;
                            } else {
                                moveDist = tickDist;
                            }
                        }

                        if ( Math.abs(currPos) + moveWindow + moveDist > myWidth ) {
                            //currPos = moveWindow - myWidth - 40 ;
                            currPos -= moveDist;
                            $(gDiv + ' .scrol-next').hide();
                            $(gDiv + ' .scroll-bg-next').css('display','none');
                        } else {
                            currPos -= moveDist;
                        }

                        myChart.css('transform','translateX(' + currPos + 'px)');
                        $(gDiv + ' .scrol-prev').show();
                        $(gDiv + ' .scroll-bg-prev').css('display','block');
                    },this);

                    $(document).on('mouseup touchend', gDiv + ' .scrol-prev', [], function(){
                        if(hasBeenTouchedRecently) {
                            return false;
                        }
                        hasBeenTouchedRecently = true;
                        setTimeout(function() { 
                            hasBeenTouchedRecently = false; 
                        }, 500);
                
                        var myChart = $(this).parent().find('.scrollingChart');
                        var currPos = myChart[0].getBBox().x;
                        var myWidth = myChart[0].getBBox().width;

                        var moveWindow = $(this).parent()[0].getBoundingClientRect().width - margin.left - margin.right ,
                            moveDist = moveWindow * 0.8; 

                        //get transform css
                        var tmp = myChart.attr('style');
                        var currPos = 0;
                        if( tmp.includes('transform') ) {
                            currPos = parseInt(tmp.split(';')[1].split('(')[1]);
                            if( isNaN(currPos) ) {
                                currPos = 0;
                            } 
                        }
                        // get tick distance 
                        var vv = [] ;
                        $(gDiv + ' .x-axis .tick').each(function(i){
                            vv[i] = $(this).attr('transform');
                        });
                        var tickDist = parseInt(vv[1].split('(')[1]) - parseInt(vv[0].split('(')[1]);
                        //if ticks spacing > move distance - center second tick
                        // and make move dist = spacer dist
                        if ( tickDist > moveDist ) {
                                moveDist = tickDist;
                        }
                        
                        if (currPos + moveDist > 0) {
                            currPos = 0;
                            $(gDiv + ' .scrol-prev').hide();
                            $(gDiv + ' .scroll-bg-prev').css('display','none');
                        } else {
                            currPos += moveDist;
                        }
                        myChart.css('transform','translateX(' + currPos + 'px)');
                        $(gDiv + ' .scrol-next').show();
                        $(gDiv + ' .scroll-bg-next').css('display','block');
                    },this);
                        
            //scrolling part
            // add prev next shaders
            chartWrapper.append('rect')
            .attr('class','scroll-bg-prev')
            .attr('x',0)
            .attr('y',0)
            .attr('width','50')
            .attr('height',chartHeight)
            .attr('fill','#fff');

            chartWrapper.append('rect')
            .attr('class','scroll-bg-next')
            .attr('x',svgWidth - margin.left - 50)
            .attr('y',0)
            .attr('width','50')
            .attr('height',chartHeight)
            .attr('fill','#fff');

        }

        LineChart.prototype.animateChart = function animateChart(gDiv, dataset) {
            d3.selectAll(gDiv + " .line").style("opacity","1");
            
                
            //Select All of the lines and process them one by one
            d3.selectAll(gDiv + " .line").each(function(d, i) {

                // Get the length of each line in turn
                var totalLength = d3.select(gDiv + " #line" + i).node().getTotalLength();

                d3.selectAll(gDiv + " #line" + i).attr("stroke-dasharray", totalLength + " " + totalLength)
                    .attr("stroke-dashoffset", totalLength)
                    .transition()
                    .duration(1000)
                    .delay(600 * (i + 1))
                    .ease(d3.easeLinear) //Try linear, quad, bounce... see other examples here - http://bl.ocks.org/hunzy/9929724
                    .attr("stroke-dashoffset", 0)
                    .style("stroke-width", 3);
            });
        }

        return function initLineChart(args) {
            return args.IsExperienceEditorEditing ? null : new LineChart(
                args.scope,
                args.chartInfo,
                args.id);
        };
    });
    
